import React from 'react';
import { Snackbar, Alert } from '@mui/material';

const NotificationToast = ({ id, type, message, onClose, autoHideDuration }) => {
  const [open, setOpen] = React.useState(true);

  const handleClose = () => {
    setOpen(false);
    onClose(id);
  };

  return (
    <Snackbar
      key={id}
      open={open}
      autoHideDuration={autoHideDuration || 3000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        onClose={handleClose}
        severity={type === 'success' ? 'success' : 'error'}
        sx={{ width: '100%' }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default NotificationToast;
